// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2iE-0","title":"ClientReferral_title__1cvwl","itemText":"ClientReferral_itemText__1DXXj"};